<!-- Hack för att inte behöva ha många likadana async pipes https://medium.com/@yurykatkov/how-to-avoid-multiple-async-pipes-in-angular-ff0d51a8d368 -->
@if ({ data: leveransvirkesplan$ | async }; as leveransvirkesplanResult) {
  <rask-toggle-panel
    #togglePanel
    label="Leveransvirkesplan"
    [showLoader]="!leveransvirkesplanResult.data"
    [defaultExpanded]="false">
    @if (leveransvirkesplanResult.data; as leveransvirkesplan) {
      @if (leveransvirkesplan.isPeriodValid()) {
        <div class="row">
          <div class="col mt-0 mb-3">
            <rask-button aid="fordelaVolym" color="secondary" (click)="onfordelaLeveransplanClick()"
              [disabled]="!leveransvirkesplan.canFordelaLeveransplan()">
              Fördela volym från åtgärder
            </rask-button>
          </div>
        </div>
      }
      @if ((messages$ | async).length > 0) {
        <div class="row mt-1 message-panel-layout">
          <rask-message-panel
            [numberOfItemsToDisplay]="3"
            [maxNumOfRows]="2"
            [items]="messages$">
          </rask-message-panel>
        </div>
      }
      @if (leveransvirkesplan.isPeriodValid()) {
        <div class="row mt-1"
          >
          <rask-hot-doc
            [hotDoc]="hotDoc">
          </rask-hot-doc>
        </div>
      }
    }
  </rask-toggle-panel>
}